import React from "react";
import styles from "./InspectorProfile.module.css";
import Header from "./Header";
import ProfileDetails from "./ProfileDetails";
import Calendar from "./Calendar";
import Services from "./Services";
import BookingButton from "./BookingButton";

function InspectorProfile({ onClose }) {
    // Ensure onClose is correctly passed here
    return (
        <div className={styles.inspectorProfile} onClick={onClose}>
            <div className={styles.messageContainer} onClick={(e) => e.stopPropagation()}>
                <main className={styles.inspectorProfileContent}>
                    <section className={styles.messageContainerContent}>
                        <div className={styles.contentWrapper}>
                            <Header />
                            <h1 className={styles.pageTitle}>Inspector Profile Details</h1>
                            <div className={styles.profileTable}>
                                <ProfileDetails />
                                <div className={styles.availabilitySection}>
                                    <div className={styles.availability}>
                                        <Calendar />
                                        <div>
                                            <Services />
                                            <BookingButton />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </div>
    );
}

export default InspectorProfile;
